const messageData = (state = [], action) => { 
    switch(action.type){  
        case 'MESSAGE_RECEIVED':  
                        console.log(receiveData)
                        var receiveData = action.payload.msg;  
                        var socketData = action.payload.socket;  
                        if(receiveData != undefined){
                            if(sessionStorage.getItem('chat_user_id') != null && sessionStorage.getItem('chat_user_id') != undefined){
                                receiveData.readAt = Date.now(); 
                                let messageIds =  [receiveData._id];
                                socketData.emit("doctor-read-message", JSON.stringify(messageIds));  
                            }
                            return [...state, receiveData]; 
                        }
                        
                        // else{
                        //     return state; 
                        // } 
        case 'READ_AT_MESSAGE_DATA':
           
                let filterMessageIds = action.payload; 
                filterMessageIds.map((messageItem) => { 
                    let updateIndexValue = state.findIndex(item => item._id === messageItem._id);
                    if(updateIndexValue >= 0){
                        state[updateIndexValue].readAt =  Date.now();   
                        return state; 
                    }
                })
            
                return state;
        case 'GET_ALL_API_MESSAGE_RECEIVED': 
                return state = action.payload;   
        default:
              return state;

    }
};

export default messageData;